import { Directive } from '@angular/core';

@Directive({
  selector: '[fixedGroupTemplate]',
  standalone: true,
})
export class FixedGroupTemplateDirective {}
